'use client';

import { useState } from 'react';
import { EmailPrefix } from '../lib/types';

interface EmailPreviewProps {
  domain: string;
  emails: EmailPrefix[];
}

export default function EmailPreview({ domain, emails }: EmailPreviewProps) {
  const [view, setView] = useState<'desktop' | 'mobile'>('desktop');

  if (emails.length === 0) return null;

  const primaryEmail = `${emails[0]}@${domain}`;

  return (
    <div className="mt-6">
      <div className="flex items-center justify-between mb-3">
        <p className="text-sm font-semibold">Aperçu</p>
        <div className="flex gap-1 bg-gray-100 rounded-lg p-0.5">
          <button
            onClick={() => setView('desktop')}
            className={`px-3 py-1 text-xs rounded-md transition-colors cursor-pointer ${
              view === 'desktop' ? 'bg-white shadow-sm font-medium' : 'text-muted'
            }`}
          >
            Desktop
          </button>
          <button
            onClick={() => setView('mobile')}
            className={`px-3 py-1 text-xs rounded-md transition-colors cursor-pointer ${
              view === 'mobile' ? 'bg-white shadow-sm font-medium' : 'text-muted'
            }`}
          >
            Mobile
          </button>
        </div>
      </div>

      <div
        className={`bg-white border border-border rounded-xl overflow-hidden shadow-sm transition-all duration-300 mx-auto ${
          view === 'mobile' ? 'max-w-[320px]' : 'max-w-full'
        }`}
      >
        {/* Email client header */}
        <div className="bg-gray-50 border-b border-border px-4 py-2.5 flex items-center gap-2">
          <div className="flex gap-1.5">
            <div className="w-3 h-3 rounded-full bg-red-400" />
            <div className="w-3 h-3 rounded-full bg-yellow-400" />
            <div className="w-3 h-3 rounded-full bg-green-400" />
          </div>
          <span className="text-xs text-muted ml-2 font-mono">{primaryEmail}</span>
        </div>

        {/* Email content */}
        <div className="p-4 sm:p-6">
          <div className="flex items-start gap-3 mb-4">
            <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center text-white font-bold text-sm shrink-0">
              {domain.charAt(0).toUpperCase()}
            </div>
            <div className="min-w-0">
              <p className="font-semibold text-sm truncate">
                {domain.replace(/\.\w+$/, '').replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
              </p>
              <p className="text-xs text-muted font-mono truncate">&lt;{primaryEmail}&gt;</p>
            </div>
          </div>

          <div className="border-t border-border pt-3">
            <p className="font-medium text-sm mb-2">Bienvenue chez nous !</p>
            <div className="space-y-2 text-xs text-muted leading-relaxed">
              <p>Bonjour,</p>
              <p>
                Merci de nous avoir contactés. Nous avons bien reçu votre
                message et nous vous répondrons dans les plus brefs délais.
              </p>
              <p>Cordialement,</p>
              <p className="font-medium text-foreground">
                L&apos;équipe {domain.replace(/\.\w+$/, '')}
              </p>
            </div>
          </div>

          <div className="mt-4 pt-3 border-t border-border">
            <p className="text-[10px] text-muted">
              Envoyé depuis {primaryEmail}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}